module.exports = __webpack_public_path__ + "fonts/material-icons-outlined.0e4321a7.woff";